import { Fragment } from 'react'

import useTranslations from '../../../hooks/useTranslations'
import ANTDDivider from '../../../shared/antd/ANTDDivider'
import { provenanceTitles, vehicleParts } from '../viewVehicle.description'

const MaterialDetails = ({ partData = {}, activeMenu, val }) => {
  const { t } = useTranslations()
  const { materialInfo } = partData
  const numberTitles = [
    'inv_FirstMaterial',
    'inv_SecondMaterial',
    'inv_ThirdMaterial',
    'inv_FourthMaterial',
    'Inv_FifthMaterial',
    'inv_SixthMaterial',
  ]

  const materialData = (data, index) => [
    [
      { label: numberTitles[index], value: t(data?.material) },
      { label: 'job_Traceability', value: data?.traceability },
      { label: 'inv_Circularity', value: data?.circularity },
    ],
    [{}, { label: 'inv_PhysicalAmount', value: data?.physicalAmount }],
    [
      {},
      {
        label: provenanceTitles[index],
        value: data?.materialProvenance,
      },
    ],
  ]

  const materialTitle = () => {
    switch (activeMenu) {
      case vehicleParts?.drumBrake:
        return `${t('inv_DrumBrake')} ${val}`

      case vehicleParts?.hubFrontWheel:
        return `${t('inv_HubFrontWheel')} ${val}`

      default:
        break
    }
  }

  return (
    <div>
      {materialInfo?.map((data, index) => (
        <Fragment key={index}>
          <table className="parts-detail-table">
            <tbody>
              <h3>{materialTitle()}</h3>
              {materialData(data, index)?.map((arr, ind) => (
                <tr key={ind}>
                  {arr?.map(({ label, value, img }, i) => (
                    <td key={i}>
                      <p>{t(label)}</p>
                      {img ? (
                        <div className="d-flex align-center">
                          <div>
                            <img className="flag-wrapper" src={img} alt="" />
                          </div>
                          <span dangerouslySetInnerHTML={{ __html: value }} />
                        </div>
                      ) : (
                        <span dangerouslySetInnerHTML={{ __html: value }} />
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
          <ANTDDivider />
        </Fragment>
      ))}
    </div>
  )
}

export default MaterialDetails
